module.exports = __webpack_public_path__ + "images/logo_appstore.png?fc1c816ab1a217a71c26d0c8451f46af";


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/assets/images/logo_appstore.png
// module id = 998
// module chunks = 0